// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-pdf__message--error {
  color: var(--TextColor);
}

.DisplayAlert {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullScreenViewer {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20;
  overflow: hidden;
}
.fullScreenViewer .closeBtn {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 1.25rem;
  color: white;
  font-weight: 600;
  cursor: pointer;
}
.fullScreenViewer #pdfBg {
  width: min-content;
  max-width: 80%;
  height: 80%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 11;
}
.fullScreenViewer #pdfBg .pdfContainer {
  width: 100%;
  overflow: auto;
  position: relative;
}
.fullScreenViewer #pdfBg .pdfContainer .upperLayer, .fullScreenViewer #pdfBg .pdfContainer .hideLayer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 12;
  overflow: auto;
}
.fullScreenViewer #pdfBg .pdfContainer .upperLayer.hide, .fullScreenViewer #pdfBg .pdfContainer .hideLayer.hide {
  backdrop-filter: blur(5px);
}

.pdfBg {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  z-index: 11;
}
.pdfBg .loadingText {
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: var(--Foreground);
  justify-content: center;
  text-align: center;
  font-size: clamp(0.625rem, 1vw, 0.875rem);
  color: var(--TextColor);
}
.pdfBg .pdfContainer {
  width: 100%;
  height: auto;
  overflow: auto;
  position: relative;
}
.pdfBg .pdfContainer .upperLayer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 12;
  overflow: auto;
}
.pdfBg .pdfContainer .pdfPage {
  min-width: none !important;
  min-height: none !important;
  width: 100% !important;
  overflow: auto;
}
.pdfBg .pdfContainer .pdfPage .react-pdf__Page__canvas {
  width: 100% !important;
  height: 100% !important;
}
.pdfBg .pagination {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.6rem;
  margin-top: 0.6rem;
}
.pdfBg .pagination p {
  font-size: 0.8rem;
  color: var(--TextColor);
}
.pdfBg .pagination button {
  padding: 0.4rem 0.5rem;
  background-color: var(--AccentColor);
  color: white;
  cursor: pointer;
  border-radius: 0.4rem;
}
.pdfBg .pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/PdfViewer/PdfViewer.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;AACJ;;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AACE;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;AAEJ;AADI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAGR;AADI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAGR;AADQ;EACI,WAAA;EAEA,cAAA;EACA,kBAAA;AAEZ;AADY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;AAGhB;AAFgB;EACI,0BAAA;AAIpB;;AAIA;EACI,sBAAA;EAEA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAGI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,uBAAA;AADR;AAGI;EACI,WAAA;EACA,YAAA;EAEA,cAAA;EACA,kBAAA;AAFR;AAGQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,WAAA;EACA,cAAA;AADZ;AAGQ;EACI,0BAAA;EACA,2BAAA;EACA,sBAAA;EAEA,cAAA;AAFZ;AAGY;EACI,sBAAA;EACA,uBAAA;AADhB;AAKI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAHR;AAIQ;EACI,iBAAA;EACA,uBAAA;AAFZ;AAIQ;EACI,sBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAFZ;AAGY;EACI,mBAAA;EACA,YAAA;AADhB","sourcesContent":[".react-pdf__message--error {\n    color: var(--TextColor);\n  }\n\n  .DisplayAlert{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .fullScreenViewer{\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    backdrop-filter: blur(5px);\n    background-color: rgba(0,0,0,.5);\n    z-index: 20;\n    overflow: hidden;\n    .closeBtn{\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        font-size: 1.25rem;\n        color: white;\n        font-weight: 600;\n        cursor: pointer;\n    }\n    #pdfBg{\n        width: min-content;\n        max-width: 80%;\n        height: 80%;\n        display: flex;\n        flex-direction: column;\n        overflow: auto;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        z-index: 11;\n        \n        .pdfContainer{\n            width: 100%;\n            // height: auto;\n            overflow: auto;\n            position: relative;\n            .upperLayer, .hideLayer{\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 100%;\n                height: 100%;\n                background-color: transparent;\n                z-index: 12;\n                overflow: auto;\n                &.hide{\n                    backdrop-filter: blur(5px);\n                }\n            }\n            \n        }\n    }\n\n  }\n.pdfBg{\n    width: 100% !important;\n    // flex: 1;\n    height: 100% !important;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    align-items: center;\n    z-index: 11;\n    .loadingText{\n        width: 100%;\n        height: 100%;\n        align-items: center;\n        background-color: var(--Foreground);\n        justify-content: center;\n        text-align: center;\n        font-size: clamp(0.625rem, 1vw, 0.875rem);\n        color: var(--TextColor);\n    }\n    .pdfContainer{\n        width: 100%;\n        height: auto;\n        // flex: 1;\n        overflow: auto;\n        position: relative;\n        .upperLayer{\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            background-color: transparent;\n            z-index: 12;\n            overflow: auto;\n        }\n        .pdfPage{\n            min-width: none !important;\n            min-height: none !important;\n            width: 100% !important;\n            // height: 100% !important;\n            overflow: auto;\n            .react-pdf__Page__canvas{\n                width: 100% !important;\n                height: 100% !important;\n            }\n        }\n    }\n    .pagination{\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        gap: .6rem;\n        margin-top: .6rem;\n        p{\n            font-size: .8rem;\n            color: var(--TextColor);\n        }\n        button{\n            padding: .4rem .5rem;\n            background-color: var(--AccentColor);\n            color: white;\n            cursor: pointer;\n            border-radius: .4rem;\n            &:disabled{\n                cursor: not-allowed;\n                opacity: .6;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
